module.exports = __webpack_public_path__ + "static/media/manage-cookies.7f715ddf.png";